import { render } from "./NavMenu.vue?vue&type=template&id=31c89fd5&scoped=true"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=31c89fd5&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c89fd5"]])

export default __exports__